import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "card"];

  connect() {
    this.buttonTargets.forEach((button) => {
      button.addEventListener("mouseenter", this.addActive);
      button.addEventListener("mouseleave", this.removeActive);

      // focus event for keyboard navigation
      button.addEventListener("focus", this.addActive);
      button.addEventListener("blur", this.removeActive);
    });
  }

  addActive(event) {
    const cardId = event.target.dataset.target;
    const card = document.getElementById(cardId);
    card?.setAttribute("data-active", true);
  }

  removeActive(event) {
    const cardId = event.target.dataset.target;
    const card = document.getElementById(cardId);
    card?.removeAttribute("data-active");
  }

  disconnect() {
    this.buttonTargets.forEach((button) => {
      button.removeEventListener("mouseenter", this.addActive);
      button.removeEventListener("mouseleave", this.removeActive);

      // focus event for keyboard navigation
      button.removeEventListener("focus", this.addActive);
      button.removeEventListener("blur", this.removeActive);
    });
  }
}
